var _a;
import { __assign } from "tslib";
import { pluginFactory } from '../../../utils/plugin-state-factory';
import { PluginKey } from 'prosemirror-state';
function reducer(pluginState, action) {
    var _a;
    switch (action.type) {
        case 'INLINE_COMMENT_RESOLVE':
            return __assign(__assign({}, pluginState), (_a = {}, _a[action.data.id] = true, _a));
        case 'SET_INLINE_COMMENT_STATE':
            return action.data;
        default:
            return pluginState;
    }
}
export var pluginKey = new PluginKey('inlineCommentPlugin');
export var createPluginState = (_a = pluginFactory(pluginKey, reducer), _a.createPluginState), createCommand = _a.createCommand;
//# sourceMappingURL=plugin-factory.js.map